export default __webpack_public_path__ + "static/media/jeep.68cbff76.jpeg";